import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { createTheme } from '@mui/material/styles';

/**
 * MUIのテーマを定義している
 */
export const theme = createTheme({
  typography: {
    fontFamily: ['YuGothic', 'Yu Gothic', 'ヒラギノ角ゴ ProN'].join(','),
  },
  palette: {
    primary: {
      main: '#014CBE',
    },
    text: {
      primary: '#1C2E2E',
    },
  },
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        colorSecondary: {
          color: '#575D64',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          height: '52px',
          width: '100%',
          padding: '0 16px',
          backgroundColor: '#ffffff',
          color: '#1C2E2E',
          display: 'flex',
          flexFlow: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderRadius: '0px',
          boxShadow: 'none',
          borderBottom: '1px solid var(--Stroke-border, #C7CCD1)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          borderRadius: '0px',
          padding: 0,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '1.125rem',
          fontWeight: 700,
          lineHeight: '175%',
          letterSpacing: '1px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: '1.5rem',
          fontWeight: 700,
          lineHeight: '32px',
          letterSpacing: '0.5px',
        },
        h2: {
          fontSize: '1.25rem',
          fontWeight: 700,
          lineHeight: '140%',
          letterSpacing: '0.5px',
        },
        h3: {
          fontSize: '1.125rem',
          fontWeight: 700,
          lineHeight: '28px',
          letterSpacing: '0.5px',
        },
        h4: {
          fontSize: '1rem',
          fontWeight: 700,
          lineHeight: '150%',
          letterSpacing: '1px',
        },
        h5: {
          fontSize: '0.875rem',
          fontWeight: 700,
          lineHeight: '20px',
          letterSpacing: '0.5px',
        },
        subtitle1: {
          fontSize: '1rem',
          fontWeight: 500,
          lineHeight: '175%',
          letterSpacing: '1px',
        },
        subtitle2: {
          fontSize: '0.875rem',
          fontWeight: 500,
          lineHeight: '175%',
          letterSpacing: '1px',
        },
        body1: {
          fontSize: '0.75rem',
          fontWeight: 500,
          lineHeight: '175%',
          letterSpacing: '1px',
        },
        body2: {
          fontSize: '0.625rem',
          fontWeight: 700,
          lineHeight: '175%',
          letterSpacing: '1px',
        },
        button: {
          fontSize: '1rem',
          fontWeight: 700,
          lineHeight: '175%',
          letterSpacing: '1px',
        },
        caption: {
          fontSize: '0.75rem',
          fontWeight: 700,
          lineHeight: '16px',
          letterSpacing: '0.5px',
          color: '#9D9D9D',
          display: 'block',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: 'linear-gradient(180deg, #0058de 0%, #00398f 100%)',
          color: '#FFFFFF',
          borderRadius: '100px',
          fontWeight: 'bold',
          '&:hover': {
            background: 'linear-gradient(180deg, #0058de 0%, #00398 100%)',
            opacity: '0.96',
          },
        },
        containedSecondary: {
          background: '#FFFFFF',
          color: '#1C2E2E',
          borderRadius: '100px',
          border: '1px solid #014CBE',
          fontWeight: 'bold',
          '&:hover': {
            background: '#e7edf7',
            opacity: '0.96',
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          padding: 0,
          marginBottom: '8px',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: 0,
          '&:hover': {
            background: 'rgba(1, 76, 190, 0.04)',
          },
          '&:focus': {
            background: '#ffffff',
          },
          '> .MuiTouchRipple-root span': {
            background: 'rgba(1, 76, 190, 0.04)',
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '0px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: '#fff',
          padding: '24px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: '#fff',
          padding: 0,
          border: '1px solid #C7CCD1',
        },
      },
    },
    MuiCardActionArea: {
      styleOverrides: {
        root: {
          '&:hover': {
            background:
              'linear-gradient(0deg, rgba(28, 46, 46, 0.50) 0%,  rgba(28, 46, 46, 0.50) 100%)',
          },
          '&:active': {
            background:
              'linear-gradient(0deg, rgba(28, 46, 46, 0.50) 0%,  rgba(28, 46, 46, 0.50) 100%)',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#575d64',
        },
        formControl: {
          position: 'static',
          transform: 'none',
          transition: 'none',
          pointerEvents: 'auto',
          cursor: 'pointer',
          display: 'inline',
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: '0',
          marginRight: '16px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          marginTop: 0,
          backgroundColor: '#ffffff',
          height: '50px',
        },
        input: {
          height: 'auto',
        },
        notchedOutline: {
          top: 0,
          legend: {
            display: 'none',
          },
        },
        multiline: {
          height: 'auto',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          color: '#575D64',
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: KeyboardArrowDownIcon,
      },
      styleOverrides: {
        root: {
          backgroundColor: '#F7F9FC',
          borderRadius: '8px',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: 'white',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: '175%',
          letterSpacing: '1px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorError: {
          backgroundColor: '#ee4f4f',
          color: '#ffffff',
          fontWeight: 'bold',
        },
        colorWarning: {
          backgroundColor: '#ff8c00',
          color: '#ffffff',
          fontWeight: 'bold',
        },
        colorInfo: {
          backgroundColor: '#FFEBCC',
          color: '#663D00',
          fontWeight: 'bold',
        },
        root: {
          backgroundColor: '#575D64',
          color: '#ffffff',
          fontWeight: 'bold',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#F7F9FC',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(even)': {
            backgroundColor: '#F7F9FC',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          fontWeight: 700,
          lineHeight: '175%',
          letterSpacing: '1px',
          padding: '16px 24px',
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          marginTop: '12px !important',
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          background: 'rgba(28, 46, 46, 0.80)',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          padding: '4px 24px',
        },
        filledWarning: {
          backgroundColor: '#FFB340',
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: '#575D64',
          '&.Mui-checked': {
            color: '#fff',
          },
        },
        track: {
          backgroundColor: '#EBEEF4',
          opacity: '1 !important',
          position: 'absolute',
          top: '5px',
          left: '4px',
          height: '28px',
          width: '50px',
          borderRadius: '32px',
        },
      },
    },
  },
});
